import { render, staticRenderFns } from "./RejectedBusinessesTable.vue?vue&type=template&id=63f1bab1&scoped=true&"
import script from "./RejectedBusinessesTable.vue?vue&type=script&lang=ts&"
export * from "./RejectedBusinessesTable.vue?vue&type=script&lang=ts&"
import style0 from "./RejectedBusinessesTable.vue?vue&type=style&index=0&id=63f1bab1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f1bab1",
  null
  
)

export default component.exports